export const STORAGE_KEYS = {
  DEPOSIT_ID: '@optimex-deposit-id',
  REFERRAL: '@optimex-referral',
  THEME: '@optimex-theme',
}
